<template>
  <ChatBox />
</template>

<script>
import ChatBox from './components/Chatbox.vue'

export default {
  name: 'App',
  components: {
    ChatBox
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

#app {
  font-family: "Montserrat", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
}
body{
  margin:0px;
  background-color: rgb(2, 3, 129);
}
</style>
